var React = require('react');

function OpenNew (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M16,16H2V2h7V0H2C0.9,0,0,0.9,0,2v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V9h-2V16z M11,0v2h3.6l-9.8,9.8l1.4,1.4L16,3.4V7\n\t\th2V0H11z"})));
}

OpenNew.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = OpenNew;

OpenNew.default = OpenNew;
